export enum CounterOfferState {
    OPEN = 'OPEN',
    OFFER_ADJUSTED = 'OFFER_ADJUSTED',
    ACCEPTED = 'ACCEPTED',
    CANCELED = 'CANCELED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
}
